import { database } from '@/services/firebase'

const agenda = {
  data () {
    return {
      agendeRef: database.ref('agenda').push()
    }
  },
  methods: {
    getEvents (driverId) {
      var app = this;
      return new Promise((resolve, reject) => {
        app.$http
        .post('service/agenda/availableByDriver', {driverId: driverId})
        .then(response => {
          console.log('getEvents response events', response.data);
          app.userEvents = {};
          var result = response.data.map(function (d) {
            console.log('map data', d.date);
            if (d.available && d.available !== '') {
              // app.userEvents[d.date] = d;
              app.userEvents[d.date] = { available: d.available.split(',').map(Number) };
              return d.date;
            } else {
              app.userEvents[d.date] = { available: [] };
            }
          });
          resolve(result);
        })
        .catch(function (error) {
          console.log('catch events:', error);
          reject(error)
        });
      })
    },
    save (data) {
      console.log('--> save events:', data);
      var app = this;
      return new Promise((resolve, reject) => {
        app.$http
        .post('service/agenda/availableByDate', data)
        .then(response => {
          // this.getEvents(this.driver.id);
          console.log('save response events', response);
          resolve(response.data);
        })
        .catch(function (error) {
          console.log('catch events:', error);
        });
      })
    },
    post2 (data) {
      this.agendeRef.child(data.driverId).update({
        [data.date]: {
          start: data.start,
          end: data.end
        }
      });
    }
  }
}

export default agenda
